import React from "react";

export const PreloadImovelDetailMobile = data => {
  return (
    <>
 <svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="1270"
  fill="none"
>
  <defs>
    <linearGradient id="shimmer1" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stopColor="#E9E9E9" />
      <stop offset="45%" stopColor="#F7F7F7" />
      <stop offset="55%" stopColor="#F7F7F7" />
      <stop offset="100%" stopColor="#E9E9E9" />
      <animateTransform
        attributeName="gradientTransform"
        type="translate"
        values="-1.5 0;1.5 0;-1.5 0"
        dur="1.7s"
        begin="0s"
        repeatCount="indefinite"
      />
    </linearGradient>

    <linearGradient id="shimmer2" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stopColor="#E9E9E9" />
      <stop offset="45%" stopColor="#F7F7F7" />
      <stop offset="55%" stopColor="#F7F7F7" />
      <stop offset="100%" stopColor="#E9E9E9" />
      <animateTransform
        attributeName="gradientTransform"
        type="translate"
        values="-1.5 0;1.5 0;-1.5 0"
        dur="1.9s"
        begin="0.35s"
        repeatCount="indefinite"
      />
    </linearGradient>

    <linearGradient id="shimmer3" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stopColor="#E9E9E9" />
      <stop offset="45%" stopColor="#F7F7F7" />
      <stop offset="55%" stopColor="#F7F7F7" />
      <stop offset="100%" stopColor="#E9E9E9" />
      <animateTransform
        attributeName="gradientTransform"
        type="translate"
        values="-1.5 0;1.5 0;-1.5 0"
        dur="1.8s"
        begin="0.7s"
        repeatCount="indefinite"
      />
    </linearGradient>

    <linearGradient id="shimmer4" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stopColor="#E9E9E9" />
      <stop offset="45%" stopColor="#F7F7F7" />
      <stop offset="55%" stopColor="#F7F7F7" />
      <stop offset="100%" stopColor="#E9E9E9" />
      <animateTransform
        attributeName="gradientTransform"
        type="translate"
        values="-1.5 0;1.5 0;-1.5 0"
        dur="2.1s"
        begin="1s"
        repeatCount="indefinite"
      />
    </linearGradient>

    <linearGradient id="shimmer5" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stopColor="#E9E9E9" />
      <stop offset="45%" stopColor="#F7F7F7" />
      <stop offset="55%" stopColor="#F7F7F7" />
      <stop offset="100%" stopColor="#E9E9E9" />
      <animateTransform
        attributeName="gradientTransform"
        type="translate"
        values="-1.5 0;1.5 0;-1.5 0"
        dur="1.6s"
        begin="0.55s"
        repeatCount="indefinite"
      />
    </linearGradient>

    <linearGradient id="shimmer6" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stopColor="#E9E9E9" />
      <stop offset="45%" stopColor="#F7F7F7" />
      <stop offset="55%" stopColor="#F7F7F7" />
      <stop offset="100%" stopColor="#E9E9E9" />
      <animateTransform
        attributeName="gradientTransform"
        type="translate"
        values="-1.5 0;1.5 0;-1.5 0"
        dur="2s"
        begin="1.2s"
        repeatCount="indefinite"
      />
    </linearGradient>

    <filter id="softShadow" x="-50%" y="-50%" width="200%" height="200%">
      <feDropShadow
        dx="0"
        dy="1"
        stdDeviation="2"
        floodColor="#000000"
        floodOpacity="0.08"
      />
    </filter>
  </defs>

  <rect
    x="0"
    y="0"
    width="100%"
    height="1270"
    fill="#FFFFFF"
  />

  <rect
    x="10"
    y="0"
    width="calc(100% - 20px)"
    height="400"
    rx="7"
    fill="url(#shimmer1)"
  />

  <svg
    x="20"
    y="180"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    overflow="visible"
    preserveAspectRatio="none"
    filter="url(#softShadow)"
  >
    <circle
      cx="20"
      cy="20"
      r="20"
      fill="#FFFFFF"
    />
    <path
      d="M22 15L17 20L22 25"
      stroke="#B5B5B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

  <svg
    x="calc(100% - 60px)"
    y="180"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    overflow="visible"
    preserveAspectRatio="none"
    filter="url(#softShadow)"
  >
    <circle
      cx="20"
      cy="20"
      r="20"
      fill="#FFFFFF"
    />
    <path
      d="M18 15L23 20L18 25"
      stroke="#B5B5B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

  <g
    transform="translate(24 355)"
    filter="url(#softShadow)"
  >
    <rect
      x="0"
      y="0"
      width="52"
      height="30"
      rx="15"
      fill="#FFFFFF"
    />
    <rect
      x="10"
      y="9"
      width="15"
      height="12"
      rx="2"
      fill="#D0D0D0"
    />
    <circle
      cx="18"
      cy="15"
      r="4"
      fill="#FFFFFF"
    />
    <path
      d="M29 20L34 15L39 20"
      stroke="#D0D0D0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>

  <rect
    x="20"
    y="450"
    width="115"
    height="18"
    rx="9"
    fill="url(#shimmer2)"
  />

  <rect
    x="20"
    y="484"
    width="250"
    height="26"
    rx="8"
    fill="url(#shimmer3)"
  />

  <rect
    x="20"
    y="523"
    width="190"
    height="16"
    rx="8"
    fill="url(#shimmer4)"
  />

  <rect
    x="20"
    y="558"
    width="calc(100% - 40px)"
    height="16"
    rx="8"
    fill="url(#shimmer5)"
  />

  <rect
    x="20"
    y="584"
    width="calc(100% - 80px)"
    height="16"
    rx="8"
    fill="url(#shimmer5)"
  />

  <rect
    x="20"
    y="636"
    width="165"
    height="24"
    rx="8"
    fill="url(#shimmer2)"
  />

  <rect
    x="20"
    y="678"
    width="calc(100% - 40px)"
    height="70"
    rx="8"
    fill="url(#shimmer6)"
  />

  <rect
    x="20"
    y="774"
    width="calc(100% - 40px)"
    height="16"
    rx="8"
    fill="url(#shimmer3)"
  />

  <rect
    x="20"
    y="801"
    width="calc(100% - 100px)"
    height="16"
    rx="8"
    fill="url(#shimmer4)"
  />

  <rect
    x="20"
    y="850"
    width="115"
    height="18"
    rx="9"
    fill="url(#shimmer2)"
  />

  <rect
    x="20"
    y="885"
    width="calc(100% - 40px)"
    height="16"
    rx="8"
    fill="url(#shimmer5)"
  />

  <rect
    x="20"
    y="912"
    width="calc(100% - 60px)"
    height="16"
    rx="8"
    fill="url(#shimmer5)"
  />

  <rect
    x="20"
    y="939"
    width="calc(100% - 120px)"
    height="16"
    rx="8"
    fill="url(#shimmer5)"
  />

  <rect
    x="20"
    y="990"
    width="calc(100% - 40px)"
    height="1"
    fill="#EEEEEE"
  />

  <rect
    x="20"
    y="1025"
    width="150"
    height="20"
    rx="10"
    fill="url(#shimmer2)"
  />

  <rect
    x="20"
    y="1062"
    width="calc(100% - 40px)"
    height="16"
    rx="8"
    fill="url(#shimmer3)"
  />

  <rect
    x="20"
    y="1089"
    width="calc(100% - 80px)"
    height="16"
    rx="8"
    fill="url(#shimmer4)"
  />

  <rect
    x="20"
    y="1135"
    width="calc(100% - 40px)"
    height="50"
    rx="8"
    fill="url(#shimmer6)"
  />

  <rect
    x="20"
    y="1205"
    width="170"
    height="18"
    rx="9"
    fill="url(#shimmer2)"
  />

  <rect
    x="20"
    y="1237"
    width="calc(100% - 40px)"
    height="16"
    rx="8"
    fill="url(#shimmer3)"
  />
</svg>  
    </>
  );
};

export default PreloadImovelDetailMobile;